<app-global-cookie></app-global-cookie>
<app-global-menu></app-global-menu>
<app-global-breadcrumb></app-global-breadcrumb>

<div class="n-section-light n-section-content-one">
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <div class="n-list-box-header">
          <h1>{{model!.title}}</h1>
          <p>{{model!.description}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">

        <div class="n-list-box-flush-image">
          <img class="n-list-box-flush-image-image" [src]="model.images[0]" [alt]="model.title" />
          <div class="n-list-box-flush-image-content">
            <p>
                {{model.description}}
            </p>
          </div> 
        </div>

      </div>
    </div>
  </div>
</div>

<div class="n-section-lighter n-section-content-one">
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <div class="n-list-box-header">
          <h2>Tours that visit</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngFor="let item of model.tours" class="col-md-4">

        <div class="n-list-box">
          <div class="n-list-box-content">
            <h2>{{item!.title}}</h2>
            <p *ngFor="let text of item.summary">
                {{text}}
            </p>
            <p>
              <a [routerLink]="['/tours', item.name]">{{item.linkText}}</a>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<app-global-footer></app-global-footer>